/**
 * Layout for shared link routes (/s/[id])
 *
 * Purpose:
 * - Wraps the /s/[id] dynamic route for Expo Router's file-based routing
 * - Enables anonymous access to public shared analysis links
 * - No header shown (clean sharing experience)
 *
 * Context:
 * - Replaces legacy /shared?token= route (removed in PR #190)
 * - Uses short_id format (10-char base62: /s/AbC123XyZ9)
 * - Registered in root _layout.tsx via <Stack.Screen name="s" />
 *
 * Related:
 * - Route component: /apps/mobile/app/s/[id].tsx
 * - Protection bypass: /apps/mobile/app/_layout.tsx:137-147
 * - Migration: 20260130000001_remove_token_validation.sql
 */
import { Stack } from 'expo-router';

export default function SLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false, // Clean experience for shared links
        // Prevent white flash during navigation by matching app's dark gradient background
        contentStyle: { backgroundColor: '#0a0012' },
        // Instant transition to eliminate white flash visibility window
        animation: 'none',
      }}
    />
  );
}
